import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../redux/actions';
import { KuposButton, KuposInput } from '../../../common';
import { SaoPauloTitle } from '../Title/SaoPauloTitle';

export const ContactForm2 = ({title, operator, headingText }) => {
  return (
    <div className="themes-contact-form-2"> 
      {headingText && <SaoPauloTitle title={ headingText } operator={operator} />}
      <div>
        <div className="contact-input-item">
          <div className="contact-input-label font11 bold">Nombre</div>
          <KuposInput type="text" placeholder="Ej. Pedro" className="kupos-border light-placeholder" />
        </div>

        <div className="contact-input-item mt20">
          <div className="contact-input-label font11 bold">Teléfono</div>
          <KuposInput type="text" placeholder="+56 9 0000 0000" className="kupos-border light-placeholder" />
        </div>

        <div className="contact-input-item mt20">
          <div className="contact-input-label font11 bold">Email</div>
          <KuposInput type="text" placeholder="ejemplo@gmail.com" className="kupos-border light-placeholder" />
        </div>

        <div className="contact-input-item mt20">
          <div className="contact-input-label font11 bold">Comentario</div>
          <KuposInput type="text" placeholder="Opcional" className="kupos-border light-placeholder" />
        </div>

        <div className="mt20">
              <KuposButton className="contact-button">ENVIAR</KuposButton>
            </div>

      </div>
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    themes: state.themes,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm2);



// WEBPACK FOOTER //
// ./src/features/themes/common/contact/ContactForm2.js